import { Actions, thunk } from 'easy-peasy';
import formatTrigger from '~/utils/formatTrigger';
import api from '~/services/api';
import { IThunkUpdateTrigger, IClientDetailsStore, IClientDetailsActions } from '../types';

const onUpdateTrigger: IThunkUpdateTrigger = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;
    const { requestInfo, requestPayload } = payload;

    const trigger = await api.clientDetails
      .updateClientTrigger(requestInfo, requestPayload)
      .then(r => formatTrigger(r.data));

    const triggers = localState.triggers.map(item => (item.id !== trigger.id ? item : trigger));

    setClientDetails({ triggers });
  },
);

export default onUpdateTrigger;
